import { useEffect } from 'react';
import { GIC_LIFECYCLE_EVENTS } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/constants.tsx';
import { useGICLifeCycleEvents } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/main.tsx';
import type { CREATE_FORM_FIELD_VALUE_CHANGE_PAYLOAD } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/types.tsx';
import { useFormContextInteractedFields } from '@atlassian/jira-issue-create-form-context/src/index.tsx';

/**
 * Save field interactions from a GIC session
 */
export const useInteractedFields = () => {
	const [interactedFields, { setInteractedWithField }] = useFormContextInteractedFields();
	const { subscribe } = useGICLifeCycleEvents();

	useEffect(
		() =>
			subscribe(
				GIC_LIFECYCLE_EVENTS.CREATE_FORM_FIELD_VALUE_CHANGE,
				({ fieldId }: CREATE_FORM_FIELD_VALUE_CHANGE_PAYLOAD) => {
					setInteractedWithField(fieldId);
				},
			),
		[setInteractedWithField, subscribe],
	);

	return {
		interactedFields,
	};
};
